import { Locale } from '../enums/locale';

export const FALLBACK_LOCALES_LIST: string[] = [];

for (const locale of Object.values(Locale)) {
  FALLBACK_LOCALES_LIST.push(locale);
}
